import React, {useState} from "react";
import {Button, Card, Col, Container, Modal, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";


interface IProps {
    open: any,
    countdown: any,
    onLogout: any,
    onContinue: any
}

const TimeoutCountdown = ({ open, countdown, onLogout, onContinue, ...props }: IProps)  => {
    const { t } = useTranslation();


//const SessionTimeoutModal: React.FC<IProps> = ({open, countdown, onLogout, onContinue}) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <Modal
            show={open}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
        >

            <Modal.Body>
                <h4>{t('captions.warning')}</h4>
                La sessione corrente scade tra {" "}
                <span>{countdown}</span> secondi.
                <br/> Tutto il lavoro non salvato andrà perso!
            </Modal.Body>
            <Modal.Footer>
                {
                    countdown > 0 ?
                        <Button className="btn_1 green" onClick={onContinue}>{t('captions.confirm')}</Button>
                        : <Button className="btn_1 yellow" onClick={onLogout}>{t('captions.continue')}</Button>
                }
            </Modal.Footer>
        </Modal>
    );
}

export default TimeoutCountdown;
